import axios from "axios";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import router from "../router/index.js";
import { ElMessage } from "element-plus";
axios.defaults.baseURL = "https://api.nxqlhhk.top";
axios.defaults.timeout = 120000;
const api = {
  get(url, param, headers) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: param,
          headers: {
            ...headers, // 👈 只拼接你真正需要的 header 字段
          },
        })
        .then((response) => resolve(response.data ? response.data : response))
        .catch((error) => reject(error));
    });
  },

  post(url, data, headers) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, {
          headers: {
            ...headers, // 👈 只拼接你真正需要的 header 字段
          },
        })
        .then((response) => resolve(response.data ? response.data : response))
        .catch((error) => reject(error));
    });
  },

  upload(url, formData, headers) {
    return new Promise((resolve, reject) => {
      if (!headers) {
        headers = {
          "Content-Type": "multipart/form-data",
        };
      }
      axios
        .post(url, formData, {
          headers: headers,
        })
        .then((response) => resolve(response.data ? response.data : response))
        .catch((error) => reject(error));
    });
  },
};
axios.interceptors.request.use(
  (config) => {
    console.log("configconfig", config);
    dealToken(config);
    checkToken(config);
    if (
      config.method === "post" &&
      config.headers["Content-Type"] !== "multipart/form-data"
    ) {
      config.headers["Content-Type"] = "application/json";
      config.data = JSON.stringify(config.data);
    }
    console.log("request:", config);
    return config;
  },
  (error) => {
    console.log("错误的传参");
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (res) => {
    console.log("response:", res.data);

    const raw = res.data;

    // 如果响应数据没有code字段，直接返回（例如SLS日志接口）
    if (raw.code === undefined) {
      return res;
    }

    // 检查code字段
    if (
      raw.code !== 200 &&
      raw.code !== "40001" &&
      raw.code !== "40000" &&
      raw.code !== "40002"
    ) {
      topMsg(raw.errorMsg || raw.message || '请求失败');
      return Promise.reject(new Error(raw.errorMsg || raw.message || '请求失败'));
    }

    return res;
  },
  (error) => {
    console.log("错误的响应", error);
    topMsg(error.message);
    return Promise.reject(error);
  },
);

function topMsg(text) {
  ElMessage({
    showClose: true,
    message: text,
    center: true,
    type: "error",
  });
}
function dealToken(config) {
  let url = config.url;
  if (url.indexOf("v4") !== -1) {
    // 设置
    var token =
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdXRoVXNlciI6eyJtZkF1dGhJZCI6ImRhNzYxNWUwNGRkMWQyY2JmZGQzYzRiNjg3ODczOWFiIiwiYXZhdGFyIjoiaHR0cHM6Ly9zdGF0aWMtbGVnYWN5LmRpbmd0YWxrLmNvbS9tZWRpYS9sUURQTTRtVDZkMWtzWG5OQTZ6TkE2eXdSdURlaDZnMU9Pc0dGX1dSMkNVX0FBXzk0MF85NDAuanBnIiwidXNlck5hbWUiOiLmooHlk7IiLCJsb2dpbk5hbWUiOiJ6aGUubGlhbmdAbW9yZWZ1bi5tZSIsInJvbGVzIjpbeyJjb2RlIjoidHJhY2tBZG1pbiIsIm5hbWUiOiLlkI7lj7DnrqHnkIblkZgiLCJyZW1hcmsiOiLlkI7lj7DnrqHnkIblkZgs6K-l6KeS6Imy5Y-v5Lul6K6_6Zeu5Z-L54K55omA5pyJ55qE6LWE5rqQIiwicm9sZUV4dCI6IntcImFjY2Vzc1wiOlwiKlwifSJ9XX19.LqTthnyml45I5zD76Qmtp92k3FtB-bnOlPOSPtNEE20";
    config.headers.Authorization = token;
  }
}

async function isTokenExpired(token) {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const exp = payload.exp;
    console.log("token", token, "payload", payload, "exp", exp);
    if (!exp) return false; // 如果没有过期时间字段，认为不过期
    console.log(
      "Date.now() >= exp * 1000",
      Date.now() >= exp * 1000,
      "exp * 1000",
      exp * 1000,
      "Date.now()",
      Date.now(),
    );
    return Date.now() >= exp * 1000;
  } catch (e) {
    return true;
  }
}

async function checkToken(config) {
  let url = config.url;
  if (url.includes("login")) {
    return true; // 如果是登录请求，直接返回 true
  }
  let token = localStorage.getItem("auth-token");
  if (!token || (await isTokenExpired(token))) {
    // 如果没有 token，跳转到登录页面
    localStorage.removeItem("auth-token");
    localStorage.removeItem("auth-user");
    router.push("/login");
    topMsg("请先登录");
    return false;
  }
  return true;
}
/**
 * 执行DataWorks SQL查询
 * @param sql 要执行的SQL语句
 * @returns {Promise<any>}
 */
async function executeDataWorksSql(sql) {
  const response = await axios.post("/dw/admin/api/v1/dataWorks/proxy", {
    sqlType: "tracking",
    isReturnResult: true,
    isStoreResult: false,
    sql: sql,
  });
  return response.data;
}

/**
 * 导出DataWorks SQL结果
 * @param sql 要执行的SQL语句
 * @returns {Promise<any>}
 */
async function exportDataWorksSqlResult(sql) {
  const response = await axios.post(
    "/v3/admin/v1/tracking/dataWorks/toExcelBySql",
    {
      sql: sql,
    },
  );
  return response.data;
}

// 默认主题配置
const defaultTheme = {
  loadingMainTitle: "马到成功",
  loadingSubTitle: "2026 丙午年 · 开工大吉",
  loadingTips: "系统正在全速启动...",
  leftLantern: "新春快乐",
  rightLantern: "马到成功",
};

// 从themes数组中随机选择一个主题
function getRandomTheme(themes) {
  if (!themes || themes.length === 0) {
    return defaultTheme;
  }
  const randomIndex = Math.floor(Math.random() * themes.length);
  return themes[randomIndex];
}

/**
 * 获取春节配置（字典表）
 * @returns {Promise<Object|null>}
 */
async function getNewYearConfig() {
  try {
    const res = await api.get("/auth/api/v1/dict/code/new_year");
    if (res && res.data && res.data.value) {
      // 解析JSON字符串
      const config = JSON.parse(res.data.value);

      // 获取时间范围
      const startDate = new Date(config.startTime);
      const endDate = new Date(config.endTime);

      // 如果有themes数组，随机选择一个
      let theme = defaultTheme;
      if (config.themes && config.themes.length > 0) {
        theme = getRandomTheme(config.themes);
      } else {
        // 兼容旧格式
        theme = {
          loadingMainTitle:
            config.loadingMainTitle || defaultTheme.loadingMainTitle,
          loadingSubTitle:
            config.loadingSubTitle || defaultTheme.loadingSubTitle,
          loadingTips: config.loadingTips || defaultTheme.loadingTips,
          leftLantern: config.leftLantern || defaultTheme.leftLantern,
          rightLantern: config.rightLantern || defaultTheme.rightLantern,
        };
      }

      return {
        startDate,
        endDate,
        ...theme,
      };
    }
    return null;
  } catch (error) {
    console.error("获取春节配置失败:", error);
    return null;
  }
}

/**
 * 获取字典配置
 * @param {string} code 字典代码
 * @returns {Promise<any>}
 */
async function getDictByCode(code) {
  try {
    const res = await api.get(`/auth/api/v1/dict/code/${code}`);
    if (res && res.data && res.data.value) {
      return JSON.parse(res.data.value);
    }
    return null;
  } catch (error) {
    console.error(`获取字典配置失败 [${code}]:`, error);
    return null;
  }
}

/**
 * 获取SLS日志产品列表
 * @returns {Promise<Array>}
 */
async function getSlsLogProductList() {
  return await getDictByCode('sls_log_product_list');
}

/**
 * 查询SLS日志
 * @param {Object} params 查询参数
 * @returns {Promise<any>}
 */
async function querySlsLog(params) {
  try {
    // 添加必需的上下文字段
    const fields = params.fields || '';
    const contextFields = '__tag__:__pack_id__,__pack_meta__';
    const finalFields = fields ? `${fields},${contextFields}` : contextFields;
    
    const response = await axios.post('/sls-log/query', {
      ...params,
      fields: finalFields
    });
    // 直接返回响应数据
    return response.data;
  } catch (error) {
    console.error('查询SLS日志失败:', error);
    throw error;
  }
}

/**
 * 获取SLS日志字段列表
 * @param {Object} params 参数
 * @returns {Promise<any>}
 */
async function getSlsLogFields(params) {
  try {
    const response = await axios.post('/sls-log/fields', params);
    // 直接返回响应数据
    return response.data;
  } catch (error) {
    console.error('获取SLS日志字段失败:', error);
    throw error;
  }
}

/**
 * 查询SLS日志上下文
 * @param {Object} params 查询参数
 * @returns {Promise<any>}
 */
async function contextQueryLogs(params) {
  try {
    const response = await axios.post('/sls-log/contextQueryLogs', params);
    return response.data;
  } catch (error) {
    console.error('查询日志上下文失败:', error);
    throw error;
  }
}

export default {
  ...api,
  executeDataWorksSql,
  exportDataWorksSqlResult,
  checkToken,
  isTokenExpired,
  getNewYearConfig,
  getDictByCode,
  getSlsLogProductList,
  querySlsLog,
  getSlsLogFields,
  contextQueryLogs,
};
